const udhrPreamble =`

Forsameikle as kenning for the inherent dignity and for the richts, equal and nane-alienable, o aw members o the human faimily is the foond o freedom, justice and peace in the warld,

Forsameikle as misregaird and contemption for human richts hes resultit in barbour acts that hes scunnert the conscience o mankind, and the advent o a warld whaur aw human sowels enjoys freedom o thocht and speech, and quittance frae dearth and dreid hes been proclaimed the tapmaist aspiration o the commonty,

Forsameikle as it is necessar, gin man be no gart tak recourse tae rebellion as a hinmaist resort conter tirannie and dounhaudenment, that human richts shuld be beildit by the rule o law,

Forsameikle as it is necessar tae gar freendly relations atween nations aye win forrit,

Forsameikle as the peoples o the Unitit Nations hes in the Chairter affirmit aince mair their faith in fundamental human richts, in the dignity and worth o the human person and in the equal richts o men and wemen and hes resolved tae promote social progress and better standarts o life in braider freedom,

Forsameikle as Member States hes gien their hecht tae win, in compluterance wi the Unitit Nations, the promotion o universal tent and respect for human richts and fundamental freedoms,

Forsameikle as a common understaunding o thir richts and freedoms is o the greatest importance for the ful kenning o this hecht,

Nou, syne,
The General Assemlie

Proclaims this Universal Declaration o Human Richts as a common standart o achievement for aw peoples and aw nations, tae the end that ilka individual and ilka organ o society, aye haudan in mind this Declaration, shal ettle throu teaching and lear tae promote respect for thir richts and freedoms and throu progressive meisures, national and international, mak sover their universal and effective kenning and tenting, baith amang the folk o the Member States theirsels and amang the folk o territours in ower their jurisdiction.`;

const udhr1 = `Aw human sowels is born free and equal in dignity and richts. They are tochered wi mense and conscience and shuld guide theirsels ane til ither in a speirit o britherheid.`;
module.exports = {
    name: "Scots", 
    udhrPreamble,
    udhr1,
    lang: 'sco',
}